import * as React from 'react'

import { Button } from '@buffer-mono/popcorn'
import type { ButtonProps } from '@buffer-mono/popcorn'

import { AIAssistantContext } from '~publish/legacy/ai/components/AIAssistant/AIAssistant'
import { ACTIONS } from '~publish/legacy/ai/components/AIAssistant/AIAssistant.constants'
import { useContentGeneration } from '~publish/legacy/ai/hooks/useContentGeneration'
import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'
import { useAppSelector } from '~publish/legacy/store'

import styles from './ActionButton.module.css'

import type { JSX } from 'react'

/**
 *
 */
function ActionButton({
  action,
  target,
  label,
  disabled,
  secondary,
  type,
  IconComponent,
  onClick,
  testId,
  size,
}: {
  action: string
  target: string | null
  label?: string
  disabled?: boolean
  secondary?: boolean
  type?: 'button' | 'submit' | 'reset'
  testId?: string
  size?: ButtonProps['size']
  IconComponent?: React.ComponentType
  onClick?: (event: React.KeyboardEvent | React.MouseEvent) => void
}): JSX.Element | null {
  const { channel } = React.useContext(AIAssistantContext)

  const { generateContent } = useContentGeneration()

  const { contentGenerationInProgress } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  const actionConfig = Object.entries(ACTIONS).find(
    ([actionKey]) => actionKey === action,
  )?.[1]

  const onGenerate = (event: React.MouseEvent): void => {
    if (!actionConfig || !target) return
    event.preventDefault()

    generateContent({
      service: channel,
      prompt: target,
      action,
      tone: null,
    })
  }

  if (!actionConfig) return null
  const Icon = IconComponent ?? actionConfig.IconComponent
  if (!Icon) return null

  return (
    <Button
      onClick={onClick || onGenerate}
      disabled={disabled || contentGenerationInProgress}
      variant={secondary ? 'secondary' : 'primary'}
      size={size}
      type={type}
      data-testid={testId}
      className={secondary ? styles.purpleIcon : styles.purpleButton}
    >
      <Icon />
      {label || actionConfig.label}
    </Button>
  )
}

export { ActionButton }
